export default "<spec-app-type12-rich-text-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type12-rich-text-table>\n";